/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-18 11:57:27
 * @LastEditTime: 2025-12-25 15:40:27
 */
import React from 'react';
import { lookReadAgreement } from "@/utils/index.js";
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/redux/hooks';
import giftImg from '@/assets/images/gift.png';
import introImg from '@/assets/images/login/intro.png';
import introImg1 from '@/assets/images/login/intro1.png';
import introImg2 from '@/assets/images/login/intro2.png';
import './index.scss';

interface Props {
  flag: number
}
const LoginHeader:React.FC<Props> = ({flag}) => { 
  const { language } = useAppSelector((state) => state.common);
  const translation = useTranslation('login');
  const isEn = language === 'en';
  const { t } = useTranslation('login');
  const introList = [
    {
      imgUrl: introImg,
      title: 'login_bg_bottom_Name1',
      text: 'login_bg_bottom_Text1'
    },
    {
      imgUrl: introImg1,
      title: 'login_bg_bottom_Name2',
      text: 'login_bg_bottom_Text2'
    },
    {
      imgUrl: introImg2,
      title: 'login_bg_bottom_Name3',
      text: 'login_bg_bottom_Text3'
    }
  ]

  return (
    <div className={`login-header-content ${flag===1&&'register-header-content'}`}>
      <p>{t('login_bg_title')}</p>
      <div className='top-tips'>
        {t('login_bg_text')}
        <img src={giftImg} alt='' />
      </div>
      <div className={`login-bottom ${isEn && 'login-bottom-en'}`}>
        <div className='experience-text'>
          <i></i>
          <span>{t('login_bg_bottom_line')}</span>
          <i></i>
        </div>
        <ul>
          {
            introList.map((iData,index) => (
              <li key={index}>
                <img src={iData.imgUrl} alt='' />
                <div className='intro-content'>
                  <p>{t(iData.title)}</p>
                  <span>{t(iData.text)}</span>
                </div>
              </li>
            ))
          }
        </ul>
      </div>
    </div>  
  )
}

export default LoginHeader;